import { Box, Paper, Stack, Tab, Tabs, Typography, useMediaQuery, useTheme } from "@mui/material";
import PropTypes from "prop-types";
import React, { useState } from "react";
import HouseGallery from "./HouseGallery";
import playButton from "../../../../images/playButton.png";
import ReactPlayer from "react-player";
import "./videoplayer.css";
import GhoramiPlayer from "../../../Custom Hooks/Video Player/GhoramiPlayer";
import { tokens } from "../../../../store/tokens";

function TabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} id={`gallery-tabpanel-${index}`} aria-labelledby={`gallery-tab-${index}`} {...other}>
      {/* This used to wrap `children` in a <Typography>, which defaults to
          rendering a <p> tag — but children here are Box/Stack elements
          (which render as <div>s), and a <div> can't legally live inside
          a <p>. Rendering children directly avoids that invalid nesting. */}
      {value === index && <Box sx={{ py: 2 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `gallery-tab-${index}`,
    "aria-controls": `gallery-tabpanel-${index}`,
  };
}

const GalleryContainer = (props) => {
  const { fetchedServicePic, fetchedServiceDetails } = props;
  const [value, setValue] = useState(0);
  const [play, setPlay] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const hasMultipleImages = fetchedServicePic && fetchedServicePic.length > 1;
  const videoType = fetchedServiceDetails?.service_video_type;
  const isYouTube = videoType === "youtube";
  const isGhoramiIntro = videoType === "ghorami";

  return (
    <Box sx={{ width: "100%", mt: { xs: "60px", md: 0 } }}>
      <Paper
              elevation={0}
              sx={{
                p: 2,
                mt: 2,
                borderRadius: `${tokens.radius.lg}px`,
                border: `1px solid ${tokens.color.line}`,
                boxShadow: tokens.shadow.md,
                bgcolor: tokens.bg.surface,
              }}
            > 
      <Box sx={{ borderBottom: `1px solid ${tokens.color.line}` }}>
        <Tabs
          value={value}
          onChange={(event, newValue) => setValue(newValue)}
          aria-label="Media Tabs"
          sx={{
            "& .MuiTab-root": { color: tokens.color.inkMuted, fontWeight: 600, textTransform: "none" },
            "& .Mui-selected": { color: tokens.color.teal },
            "& .MuiTabs-indicator": { backgroundColor: tokens.color.teal },
          }}
        >
          <Tab label="Picture" {...a11yProps(0)} sx={{ width: "50%" }} />
          <Tab label="Video" {...a11yProps(1)} sx={{ width: "50%" }} />
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        {hasMultipleImages ? (
          <HouseGallery fetchedServicePic={fetchedServicePic} />
        ) : (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Box
              component="img"
              src={fetchedServicePic?.[0]?.mpic ?? fetchedServiceDetails?.pic}
              alt="Service preview"
              sx={{
                width: "auto",
                height: "55vh",
                borderRadius: `${tokens.radius.md}px`,
                boxShadow: tokens.shadow.sm,
                transition: "transform 0.3s ease-in-out",
                "&:hover": { transform: "scale(1.05)" },
              }}
            />
          </Box>
        )}
      </TabPanel>

      <TabPanel value={value} index={1}>
        <Stack justifyContent="center" alignItems="center" sx={{ position: "relative" }}>
          {isYouTube ? (
            <>
              <ReactPlayer
                width="100%"
                height={isMobile ? "40vh" : "48.5vh"}
                controls
                playing={play}
                url={fetchedServiceDetails?.service_video_url}
              />
              {!play && (
                <Box
                  onClick={() => setPlay(true)}
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: isMobile ? "40vh" : "48.5vh",
                    bgcolor: "rgba(18,36,46,0.35)",
                    zIndex: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    borderRadius: `${tokens.radius.md}px`,
                  }}
                >
                  <Box
                    component="img"
                    src={playButton}
                    alt="Play"
                    sx={{ width: 64, height: 64, transition: "transform 0.3s ease", "&:hover": { transform: "scale(1.1)" } }}
                  />
                </Box>
              )}
            </>
          ) : (
            // Was `service_video_type === "ghorami" ? true : "songjukti" ? true : false` —
            // "songjukti" is a non-empty string, so that expression is
            // ALWAYS truthy and the hardcoded intro clip below played for
            // every video type, never the real per-service URL. Now it
            // only plays the shared intro for the "ghorami" type, and
            // falls through to the real per-service URL otherwise.
            <Box sx={{ width: "100%" }}>
              <div style={{ position: "relative", width: "100%", paddingTop: "56.25%" }}>
                <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}>
                  {isGhoramiIntro ? (
                    <GhoramiPlayer
                      playerHeight="65vh"
                      videoUrl="//aps.songjukti.com/image/ghorami_Intro.mp4"
                      adUrl="//aps.songjukti.com/image/ghorami_Intro.mp4"
                      subtitles={[
                        { label: "English", src: "/subs/eng.vtt", srclang: "en", default: true },
                        { label: "Bangla", src: "/subs/bn.vtt", srclang: "bn" },
                      ]}
                    />
                  ) : (
                    <GhoramiPlayer videoUrl={`//yeapbe.com/${fetchedServiceDetails?.videoUrl?.subId}`} playerHeight="65vh" />
                  )}
                </div>
              </div>
            </Box>
          )}
        </Stack>
      </TabPanel>

      </Paper>
    </Box>
  );
};

export default GalleryContainer;